import script from "./verifyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./verifyDialog.vue?vue&type=script&setup=true&lang=js"

import "./verifyDialog.vue?vue&type=style&index=0&id=c619de92&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c619de92"]])

export default __exports__